import McpLogoIcon from "@/assets/icons/mcplogo.svg?react";
import { cn } from "@/lib/utils";

type McpLogoProps = {
  className?: string;
};

export default function McpLogo({ className }: McpLogoProps) {
  return <McpLogoIcon className={cn("shrink-0", className)} aria-hidden />;
}
